import type { Directive, DirectiveBinding } from 'vue'
import { nextTick } from 'vue'

const __SCOPE__ = 'scope'

// 为 el 单独指定类型
type InfiniteScrollEl = HTMLElement & {
  [__SCOPE__]: {
    onScroll: () => void
  }
}
export enum DirTypeEnum {
  UP,
  DOWN
}
interface DirectiveOpt {
  itemHeight: number /// 内部每一列数据的高度
  delay: number // 每次更新刷新数据的频率
  load: (dir: DirTypeEnum) => void // 维护数据源的函数
}

const getOptions = (binding: DirectiveBinding<DirectiveOpt>): DirectiveOpt => {
  const itemHeight = binding.value.itemHeight || 5
  const delay = binding.value.delay || 500
  const load = binding.value.load || (() => {})

  return { itemHeight, delay, load }
}

export const chatInfiniteScrollDirective: Directive<InfiniteScrollEl, DirectiveOpt> = {
  // 在绑定元素的父组件
  // 及他自己的所有子节点都挂载完成后调用
  async mounted(el, binding, vnode, prevVnode) {
    await nextTick()
    const { delay, load, itemHeight } = getOptions(binding)
    let timer: number | null = null
    /**
     * scrollTop：滚动条滚动距离
     * scrollHeight：滚动条的实际高度
     * clientHeight：元素的高度
     * 随着滚动条滚到底部，此时 scrollTop + clientHeight = scrollHeight，那么此时就可以判断到达底部了
     */
    const onScroll = async () => {
      timer && clearTimeout(timer)
      /**
       * 滚动条滚动距离 也就是距离顶部的距离
       */
      const scrollTop = el.scrollTop
      /**
       * 滚动条的高度 也就是整个内容块的高度（包括隐藏的和显示的）
       */
      const scrollHeight = el.scrollHeight
      /**
       * 元素的高度 也就是显示的区域高度（此高度是不变的）
       */
      const clientHeight = el.clientHeight
      /**
       * 当前滚动到的底部位置
       */
      const currentHeight = scrollTop + clientHeight
      /**
       * 如果当前滚动到的底部位置 大于等于 滚动条的高度 表示到达了底部
       */
      if (currentHeight >= scrollHeight - 10) {
        timer = setTimeout(() => load(DirTypeEnum.DOWN), delay)
        //
        await nextTick() // 等待新增的元素加载完毕
      } else if (scrollTop <= 1) {
        timer = setTimeout(() => load(DirTypeEnum.UP), delay)
        await nextTick() // 等待新增的元素加载完毕
        // el.scrollTop = itemHeight
      }
    }

    el[__SCOPE__] = { onScroll }

    el.addEventListener('scroll', onScroll)
  },
  // 绑定元素的父组件卸载后调用
  unmounted(el, binding, vnode, prevVnode) {
    const { onScroll } = el[__SCOPE__]
    window.removeEventListener('scroll', onScroll)
  }
}
